import { withInstall } from '@ll-plus/utils'

import StatisticCountdown from './src/statistic-countdown.vue'
import Statistic from './src/statistic.vue'

export const LlStatistic = withInstall(Statistic)
export const LlStatisticCountdown = withInstall(StatisticCountdown)

export * from './src/statistic'

declare module 'vue' {
  export interface GlobalComponents {
    LlStatistic: typeof Statistic
    LlStatisticCountdown: typeof StatisticCountdown
  }
}
